import { VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'
import DeliveryPoint from '@/dto/deliveries/DeliveryPoint'
import deliveryStore from '@/stores/DeliveryStore'
import DeliveryPointsService from '@/services/DeliveryPointsService'
import shipmentStore from '@/stores/ShipmentStore'
import ShipmentPoint from '@/dto/deliveries/ShipmentPoint'

@DynamicModule
class CreateDeliveryPointStore extends VuexModule {
  static localStorageKey: string = 'newDeliveryPoint'
  public model: DeliveryPoint | null = null

  @Mutation
  public setModel(model: DeliveryPoint | null) {
    this.model = model

    if (this.model) {
      this.model.deliveryId = deliveryStore.deliveryId as number
    }
  }

  @Action
  public async setFromExistModel(model: DeliveryPoint) {
    const clone = Object.assign({}, model)
    clone.id = null

    this.setModel(clone)
  }

  @Action
  public setClearModel() {
    const model = DeliveryPointsService.makeDeliveryPointModel({
      deliveryId: deliveryStore.deliveryId as number,
      cityId: (shipmentStore.shipmentPoint as ShipmentPoint).city.id,
    })

    this.setModel(model)
  }
}

export default getModule(CreateDeliveryPointStore)
